import request from '@/utils/request'

const busUrl = window.g.baseURL1

export function userLogin(query) {
    return request({
        url: busUrl + '/web/user/login',
        method: 'post',
        params: query
    })
}

//用户退出
export function userExit() {
    return request({
        url: busUrl + '/web/user/exit',
        method: 'post'
    })
}

//用户注册
export function userAdd(query) {
    return request({
        url: busUrl + '/web/user/form',
        method: 'post',
        params: query
    })
}

//用户资料提交
export function userFile(data) {
    return request({
        url: busUrl + '/web/user/file',
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data
    })
}



// WEBPACK FOOTER //
// ./src/api/userlogin.js